// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"6f540ff4acbcfd06496f","731":"84194d65823ed2cf0b65","843":"9b2cbd26dd40714d5589","883":"dc4420c884b886dc50bf"}[chunkId] + ".js";
};